export default [
	{"name": "Administrador de Rede", "id": "Administrador de Rede"},
	{"name": "Administrador", "id": "Administrador"},
	{"name": "Administrador de Banco de Dados", "id": "Administrador de Banco de Dados"},
	{"name": "Administrador de Empresas", "id": "Administrador de Empresas"},
	{"name": "Administrador de Recursos Humanos", "id": "Administrador de Recursos Humanos"},
	{"name": "Administrador Hospitalar", "id": "Administrador Hospitalar"},
	{"name": "Administrador de Serviços do Lar", "id": "Administrador de Serviços do Lar"},
	{"name": "Advogado", "id": "Advogado"},
	{"name": "Agente Ambiental", "id": "Agente Ambiental"},
	{"name": "Agricultor", "id": "Agricultor"},
	{"name": "Agrônomo", "id": "Agrônomo"},
	{"name": "Agropecuarista", "id": "Agropecuarista"},
	{"name": "Ajudante de Caminhão", "id": "Ajudante de Caminhão"},
	{"name": "Ajudante de Composição", "id": "Ajudante de Composição"},
	{"name": "Ajudante de Foguista", "id": "Ajudante de Foguista"},
	{"name": "Ajudante de Vidreiro", "id": "Ajudante de Vidreiro"},
	{"name": "Almoxarife", "id": "Almoxarife"},
	{"name": "Analista", "id": "Analista"},
	{"name": "Analista Administrativo", "id": "Analista Administrativo"},
	{"name": "Analista Contábil", "id": "Analista Contábil"},
	{"name": "Analista de Administração de Pessoal", "id": "Analista de Administração de Pessoal"},
	{"name": "Analista de Captação", "id": "Analista de Captação"},
	{"name": "Analista de Contratos", "id": "Analista de Contratos"},
	{"name": "Analista de Controladoria", "id": "Analista de Controladoria"},
	{"name": "Analista de Controle Interno", "id": "Analista de Controle Interno"},
	{"name": "Analista de Crédito", "id": "Analista de Crédito"},
	{"name": "Analista de Custos", "id": "Analista de Custos"},
	{"name": "Analista de Departamento Pessoal", "id": "Analista de Departamento Pessoal"},
	{"name": "Analista de Exportação", "id": "Analista de Exportação"},
	{"name": "Analista de Faturamento", "id": "Analista de Faturamento"},
	{"name": "Analista de TI", "id": "Analista de TI"},
	{"name": "Analista de Laboratório", "id": "Analista de Laboratório"},
	{"name": "Analista de Logística", "id": "Analista de Logística"},
	{"name": "Analista de Marketing", "id": "Analista de Marketing"},
	{"name": "Analista de Negócios", "id": "Analista de Negócios"},
	{"name": "Analista de Orçamentos", "id": "Analista de Orçamentos"},
	{"name": "Analista de Organização e Métodos", "id": "Analista de Organização e Métodos"},
	{"name": "Analista de Pessoal", "id": "Analista de Pessoal"},
	{"name": "Analista de Recursos Humanos", "id": "Analista de Recursos Humanos"},
	{"name": "Analista de Remuneração Senior", "id": "Analista de Remuneração Senior"},
	{"name": "Analista de Sistemas", "id": "Analista de Sistemas"},
	{"name": "Analista de Suporte Administrativo", "id": "Analista de Suporte Administrativo"},
	{"name": "Analista de Suporte Pleno", "id": "Analista de Suporte Pleno"},
	{"name": "Analista de Tecidos", "id": "Analista de Tecidos"},
	{"name": "Analista de Vendas", "id": "Analista de Vendas"},
	{"name": "Analista Financeiro", "id": "Analista Financeiro"},
	{"name": "Analista Fiscal", "id": "Analista Fiscal"},
	{"name": "Analista Senior de Previdência Privada", "id": "Analista Senior de Previdência Privada"},
	{"name": "Analista Tributária", "id": "Analista Tributária"},
	{"name": "Apicultor", "id": "Apicultor"},
	{"name": "Aposentado", "id": "Aposentado"},
	{"name": "Armador de Pesca", "id": "Armador de Pesca"},
	{"name": "Arquiteto", "id": "Arquiteto"},
	{"name": "Artesão", "id": "Artesão"},
	{"name": "Assistente Administrativo", "id": "Assistente Administrativo"},
	{"name": "Assistente Comercial", "id": "Assistente Comercial"},
	{"name": "Assistente Contábil", "id": "Assistente Contábil"},
	{"name": "Assistente de Contas", "id": "Assistente de Contas"},
	{"name": "Assistente de Departamento Pessoal", "id": "Assistente de Departamento Pessoal"},
	{"name": "Assistente de Escritório", "id": "Assistente de Escritório"},
	{"name": "Assistente de Faturamento", "id": "Assistente de Faturamento"},
	{"name": "Assistente de Gerencia de R.H.", "id": "Assistente de Gerencia de R.H."},
	{"name": "Assistente de Hotelaria Hospitalar", "id": "Assistente de Hotelaria Hospitalar"},
	{"name": "Assistente de Planejamento", "id": "Assistente de Planejamento"},
	{"name": "Assistente de Processo", "id": "Assistente de Processo"},
	{"name": "Assistente de Produção", "id": "Assistente de Produção"},
	{"name": "Assistente de Recursos Humanos", "id": "Assistente de Recursos Humanos"},
	{"name": "Assistente de Suprimentos", "id": "Assistente de Suprimentos"},
	{"name": "Assistente Financeiro", "id": "Assistente Financeiro"},
	{"name": "Assistente Jurídico", "id": "Assistente Jurídico"},
	{"name": "Assistente Social", "id": "Assistente Social"},
	{"name": "Assistente Técnico Operacional", "id": "Assistente Técnico Operacional"},
	{"name": "Atendente", "id": "Atendente"},
	{"name": "Ator/Atriz", "id": "Ator/Atriz"},
	{"name": "Auditor", "id": "Auditor"},
	{"name": "Auditor Fiscal", "id": "Auditor Fiscal"},
	{"name": "Autônomo", "id": "Autônomo"},
	{"name": "Aux. de Serviços Gerais", "id": "Aux. de Serviços Gerais"},
	{"name": "Auxiliar Acadêmico", "id": "Auxiliar Acadêmico"},
	{"name": "Auxiliar Administrativo", "id": "Auxiliar Administrativo"},
	{"name": "Auxiliar Contábil", "id": "Auxiliar Contábil"},
	{"name": "Auxiliar de Compras", "id": "Auxiliar de Compras"},
	{"name": "Auxiliar de Cozinha", "id": "Auxiliar de Cozinha"},
	{"name": "Auxiliar de Departamento de Crédito", "id": "Auxiliar de Departamento de Crédito"},
	{"name": "Auxiliar de Departamento Financeiro", "id": "Auxiliar de Departamento Financeiro"},
	{"name": "Auxiliar de Departamento Fiscal", "id": "Auxiliar de Departamento Fiscal"},
	{"name": "Auxiliar de eletricista", "id": "Auxiliar de eletricista"},
	{"name": "Auxiliar de Enfermagem", "id": "Auxiliar de Enfermagem"},
	{"name": "Auxiliar de Escritório", "id": "Auxiliar de Escritório"},
	{"name": "Auxiliar de Inspeção de Qualidade", "id": "Auxiliar de Inspeção de Qualidade"},
	{"name": "Auxiliar de Laboratório", "id": "Auxiliar de Laboratório"},
	{"name": "Auxiliar de Produção", "id": "Auxiliar de Produção"},
	{"name": "Auxiliar de Registro de Saúde", "id": "Auxiliar de Registro de Saúde"},
	{"name": "Auxiliar de RH", "id": "Auxiliar de RH"},
	{"name": "Auxiliar de Serviços", "id": "Auxiliar de Serviços"},
	{"name": "Auxiliar Financeiro", "id": "Auxiliar Financeiro"},
	{"name": "Auxiliar Operacional", "id": "Auxiliar Operacional"},
	{"name": "Auxiliar Técnico", "id": "Auxiliar Técnico"},
	{"name": "Avicultor", "id": "Avicultor"},
	{"name": "Bailarino", "id": "Bailarino"},
	{"name": "Bancário", "id": "Bancário"},
	{"name": "Biólogo", "id": "Biólogo"},
	{"name": "Biomédico", "id": "Biomédico"},
	{"name": "Cabeleireiro", "id": "Cabeleireiro"},
	{"name": "Caminhoneiro", "id": "Caminhoneiro"},
	{"name": "Catador", "id": "Catador"},
	{"name": "Chefe da Secretaria de Expediente", "id": "Chefe da Secretaria de Expediente"},
	{"name": "Chefe de Recursos Humanos", "id": "Chefe de Recursos Humanos"},
	{"name": "Chefe de Serviços de Transporte", "id": "Chefe de Serviços de Transporte"},
	{"name": "Cirurgião Dentista", "id": "Cirurgião Dentista"},
	{"name": "Citricultor", "id": "Citricultor"},
	{"name": "Coletor de Material Reciclável", "id": "Coletor de Material Reciclável"},
	{"name": "Comerciante", "id": "Comerciante"},
	{"name": "Comerciário", "id": "Comerciário"},
	{"name": "Comprador", "id": "Comprador"},
	{"name": "Comunicador Social", "id": "Comunicador Social"},
	{"name": "Condutor Autônomo", "id": "Condutor Autônomo"},
	{"name": "Condutor Escolar", "id": "Condutor Escolar"},
	{"name": "Conferente", "id": "Conferente"},
	{"name": "Construtor", "id": "Construtor"},
	{"name": "Consultor Administrativo", "id": "Consultor Administrativo"},
	{"name": "Consultor de Vendas", "id": "Consultor de Vendas"},
	{"name": "Contabilista", "id": "Contabilista"},
	{"name": "Contador", "id": "Contador"},
	{"name": "Contramestre", "id": "Contramestre"},
	{"name": "Coordenador", "id": "Coordenador"},
	{"name": "Coordenador Administrativo Pessoal", "id": "Coordenador Administrativo Pessoal"},
	{"name": "Coordenador de Atendimento", "id": "Coordenador de Atendimento"},
	{"name": "Coordenador de Controladoria", "id": "Coordenador de Controladoria"},
	{"name": "Coordenador de Controle de Qualidade", "id": "Coordenador de Controle de Qualidade"},
	{"name": "Coordenador de Controle Interno", "id": "Coordenador de Controle Interno"},
	{"name": "Coordenador de Engenharia Industrial", "id": "Coordenador de Engenharia Industrial"},
	{"name": "Coordenador de Exportação", "id": "Coordenador de Exportação"},
	{"name": "Coordenador de Impostos", "id": "Coordenador de Impostos"},
	{"name": "Coordenador de Instrumentos", "id": "Coordenador de Instrumentos"},
	{"name": "Coordenador de Manutenção", "id": "Coordenador de Manutenção"},
	{"name": "Coordenador de Produção", "id": "Coordenador de Produção"},
	{"name": "Coordenador de Projetos", "id": "Coordenador de Projetos"},
	{"name": "Coordenador de Recursos Humanos", "id": "Coordenador de Recursos Humanos"},
	{"name": "Coordenador de Suprimentos", "id": "Coordenador de Suprimentos"},
	{"name": "Coordenador de Transportes", "id": "Coordenador de Transportes"},
	{"name": "Coordenador de Vendas", "id": "Coordenador de Vendas"},
	{"name": "Coordenador Pedagógico", "id": "Coordenador Pedagógico"},
	{"name": "Coreógrafo", "id": "Coreógrafo"},
	{"name": "Corretor de Imóveis", "id": "Corretor de Imóveis"},
	{"name": "Corretor de Seguros", "id": "Corretor de Seguros"},
	{"name": "Costureiro", "id": "Costureiro"},
	{"name": "Cozinheiro", "id": "Cozinheiro"},
	{"name": "Cronoanalista", "id": "Cronoanalista"},
	{"name": "Cuidador de idoso", "id": "Cuidador de idoso"},
	{"name": "Dançarino", "id": "Dançarina"},
	{"name": "Delegado", "id": "Delegado"},
	{"name": "Dentista", "id": "Dentista"},
	{"name": "Desenvolvedor de Arte", "id": "Desenvolvedor de Arte"},
	{"name": "Desenvolvedor de Produtos Texteis", "id": "Desenvolvedor de Produtos Texteis"},
	{"name": "Designer", "id": "Designer"},
	{"name": "Despachante", "id": "Despachante"},
	{"name": "Digitador", "id": "Digitador"},
	{"name": "Diretor", "id": "Diretor"},
	{"name": "Diretor Executivo ", "id": "Diretor Executivo "},
	{"name": "Diretor de Escola", "id": "Diretor de Escola"},
	{"name": "Diretor de Recursos Humanos", "id": "Diretor de Recursos Humanos"},
	{"name": "Diretor de Assuntos Técnicos", "id": "Diretor de Assuntos Técnicos"},
	{"name": "Diretor de Criação", "id": "Diretor de Criação"},
	{"name": "Diretor de Produções", "id": "Diretor de Produções"},
	{"name": "Diretor de Relações Públicas", "id": "Diretor de Relações Públicas"},
	{"name": "Diretor de Relações Públicas e Sociais", "id": "Diretor de Relações Públicas e Sociais"},
	{"name": "Economista", "id": "Economista"},
	{"name": "Eletricista", "id": "Eletricista"},
	{"name": "Eletricitário", "id": "Eletricitário"},
	{"name": "Embalador", "id": "Embalador"},
	{"name": "Embalador de Produtos", "id": "Embalador de Produtos"},
	{"name": "Empregada Doméstica", "id": "Empregada Doméstica"},
	{"name": "Empresário", "id": "Empresário"},
	{"name": "Empresário Rural", "id": "Empresário Rural"},
	{"name": "Encarregado Automotivo", "id": "Encarregado Automotivo"},
	{"name": "Encarregado de Controladoria", "id": "Encarregado de Controladoria"},
	{"name": "Encarregado", "id": "Encarregado"},
	{"name": "Encarregado de Mídia", "id": "Encarregado de Mídia"},
	{"name": "Enfermeiro", "id": "Enfermeiro"},
	{"name": "Engenheiro", "id": "Engenheiro"},
	{"name": "Engenheiro Administrador", "id": "Engenheiro Administrador"},
	{"name": "Engenheiro Agrônomo", "id": "Engenheiro Agrônomo"},
	{"name": "Engenheiro Civil", "id": "Engenheiro Civil"},
	{"name": "Engenheiro de Alimentos", "id": "Engenheiro de Alimentos"},
	{"name": "Engenheiro de Desenvolvimento Ambiental", "id": "Engenheiro de Desenvolvimento Ambiental"},
	{"name": "Engenheiro de Segurança do Trabalho", "id": "Engenheiro de Segurança do Trabalho"},
	{"name": "Engenheiro Eletricista", "id": "Engenheiro Eletricista"},
	{"name": "Engenheiro Florestal", "id": "Engenheiro Florestal"},
	{"name": "Engenheiro Mecânico", "id": "Engenheiro Mecânico"},
	{"name": "Engenheiro Naval", "id": "Engenheiro Naval"},
	{"name": "Engenheiro Químico", "id": "Engenheiro Químico"},
	{"name": "Escrevente Técnico Judiciário", "id": "Escrevente Técnico Judiciário"},
	{"name": "Escrituraria", "id": "Escrituraria"},
	{"name": "Escriturario", "id": "Escriturario"},
	{"name": "Especialista em Banco de Dados", "id": "Especialista em Banco de Dados"},
	{"name": "Estudante", "id": "Estudante"},
	{"name": "Farmacêutico", "id": "Farmacêutico"},
	{"name": "Faturista", "id": "Faturista"},
	{"name": "Faxineiro", "id": "Faxineiro"},
	{"name": "Ferramenteiro", "id": "Ferramenteiro"},
	{"name": "Ferroviário", "id": "Ferroviário"},
	{"name": "Fisioterapeuta", "id": "Fisioterapeuta"},
	{"name": "Floricultor", "id": "Floricultor"},
	{"name": "Fotógrafo", "id": "Fotógrafo"},
	{"name": "Funcionário Público", "id": "Funcionário Público"},
	{"name": "funileiro", "id": "funileiro"},
	{"name": "Geógrafo", "id": "Geógrafo"},
	{"name": "Geólogo", "id": "Geólogo"},
	{"name": "Gerente", "id": "Gerente"},
	{"name": "Gerente de Área", "id": "Gerente de Área"},
	{"name": "Gerente de Contabilidade", "id": "Gerente de Contabilidade"},
	{"name": "Gerente de Crédito e Cobrança", "id": "Gerente de Crédito e Cobrança"},
	{"name": "Gerente de Faturamento", "id": "Gerente de Faturamento"},
	{"name": "Gerente de Recursos Humanos", "id": "Gerente de Recursos Humanos"},
	{"name": "Gerente de Serviços de Transporte", "id": "Gerente de Serviços de Transporte"},
	{"name": "Gerente de Sistemas", "id": "Gerente de Sistemas"},
	{"name": "Gerente de Tecnologa da Informação", "id": "Gerente de Tecnologa da Informação"},
	{"name": "Gerente de Tributário", "id": "Gerente de Tributário"},
	{"name": "Gerente de Vendas", "id": "Gerente de Vendas"},
	{"name": "Gerente de Vendas Distribuidores", "id": "Gerente de Vendas Distribuidores"},
	{"name": "Gerente Departamento de Compra", "id": "Gerente Departamento de Compra"},
	{"name": "Gerente Financeiro", "id": "Gerente Financeiro"},
	{"name": "Gerente Operacional", "id": "Gerente Operacional"},
	{"name": "Gerente Regional de Vendas", "id": "Gerente Regional de Vendas"},
	{"name": "Gestor de Logística", "id": "Gestor de Logística"},
	{"name": "Gestor de Negócios", "id": "Gestor de Negócios"},
	{"name": "Gestor de Projetos", "id": "Gestor de Projetos"},
	{"name": "Gestor Financeiro", "id": "Gestor Financeiro"},
	{"name": "Historiador", "id": "Historiador"},
	{"name": "Impressor", "id": "Impressor"},
	{"name": "Industriário", "id": "Industriário"},
	{"name": "Inspetor de Qualidade", "id": "Inspetor de Qualidade"},
	{"name": "Instrumentista", "id": "Instrumentista"},
	{"name": "Intérprete", "id": "Intérprete"},
	{"name": "Jardineiro", "id": "Jardineiro"},
	{"name": "Jornalista", "id": "Jornalista"},
	{"name": "Lavrador", "id": "Lavrador"},
	{"name": "Líder de Embalagem", "id": "Líder de Embalagem"},
	{"name": "Líder de Higienização", "id": "Líder de Higienização"},
	{"name": "Líder de Recepção", "id": "Líder de Recepção"},
	{"name": "Marceneiro", "id": "Marceneiro"},
	{"name": "Matemático", "id": "Matemático"},
	{"name": "Mecânico", "id": "Mecânico"},
	{"name": "Mecânico de Manutenção", "id": "Mecânico de Manutenção"},
	{"name": "Medico", "id": "Medico"},
	{"name": "Médico Pediátrico", "id": "Médico Pediátrico"},
	{"name": "Médico Veterinário", "id": "Médico Veterinário"},
	{"name": "Metalúrgico", "id": "Metalúrgico"},
	{"name": "Militar", "id": "Militar"},
	{"name": "Ministro Religioso", "id": "Ministro Religioso"},
	{"name": "Motorista", "id": "Motorista"},
	{"name": "Nutricionista", "id": "Nutricionista"},
	{"name": "Odontólogo ", "id": "Odontólogo "},
	{"name": "Oficial de Cartório", "id": "Oficial de Cartório"},
	{"name": "Oficial de Justiça", "id": "Oficial de Justiça"},
	{"name": "Oficial de Promotoria", "id": "Oficial de Promotoria"},
	{"name": "Oleiro", "id": "Oleiro"},
	{"name": "Operador", "id": "Operador "},
	{"name": "Operador de Crédito Rural", "id": "Operador  de Crédito Rural"},
	{"name": "Operador de Caldeira", "id": "Operador de Caldeira"},
	{"name": "Operador de Conicaleira", "id": "Operador de Conicaleira"},
	{"name": "Operador de Máquina", "id": "Operador de Máquina"},
	{"name": "Operador de Texturização", "id": "Operador de Texturização"},
	{"name": "Operador de Forming", "id": "Operador de Forming"},
	{"name": "Operador de Imagem", "id": "Operador de Imagem"},
	{"name": "Operador de Máquinas", "id": "Operador de Máquinas"},
	{"name": "Orientador Educacional", "id": "Orientador Educacional"},
	{"name": "Pecuarista", "id": "Pecuarista"},
	{"name": "Pedagogo", "id": "Pedagogo"},
	{"name": "Pedreiro", "id": "pedreiro"},
	{"name": "Pedreiro Refratarista", "id": "Pedreiro Refratarista"},
	{"name": "Planejador de Manutenção", "id": "Planejador de Manutenção"},
	{"name": "Policial", "id": "Policial"},
	{"name": "Policial Rodoviário", "id": "Policial Rodoviário"},
	{"name": "Porteiro", "id": "Porteiro"},
	{"name": "Prensista", "id": "Prensista"},
	{"name": "Produtor Agropecuário", "id": "Produtor Agropecuário"},
	{"name": "Produtor Rural", "id": "Produtor Rural"},
	{"name": "Professor", "id": "Professor"},
	{"name": "Profissional Liberal", "id": "Profissional Liberal"},
	{"name": "Programador", "id": "Programador"},
	{"name": "Psicólogo", "id": "Psicólogo"},
	{"name": "Publicitário", "id": "Publicitário"},
	{"name": "Químico", "id": "Químico"},
	{"name": "Reciclador", "id": "Reciclador"},
	{"name": "Recobridor", "id": "Recobridor"},
	{"name": "Representante Comercial", "id": "Representante Comercial"},
	{"name": "Secretário de Diretoria", "id": "Secretário de Diretoria"},
	{"name": "Secretário Executiva", "id": "Secretário Executiva"},
	{"name": "Secretário", "id": "Secretário"},
	{"name": "Securitário", "id": "Securitário"},
	{"name": "Segurança", "id": "Segurança"},
	{"name": "Selecionador", "id": "Selecionador"},
	{"name": "Serralheiro", "id": "Serralheiro"},
	{"name": "Servidor Público", "id": "Servidor Público"},
	{"name": "Sociólogo", "id": "Sociólogo"},
	{"name": "Supervisor", "id": "Supervisor"},
	{"name": "Supervisor Administrativo", "id": "Supervisor Administrativo"},
	{"name": "Supervisor de Administração de Pessoal", "id": "Supervisor de Adminstração de Pessoal"},
	{"name": "Supervisor de Atendimento", "id": "Supervisor de Atendimento"},
	{"name": "Supervisor de Compras", "id": "Supervisor de Compras"},
	{"name": "Supervisor de Custos", "id": "Supervisor de Custos"},
	{"name": "Supervisor de Elétrica e Instrumentação", "id": "Supervisor de Elétrica e Instrumentação"},
	{"name": "Supervisor de Manufatura", "id": "Supervisor de Manufatura"},
	{"name": "Supervisor de Manutenção Industrial", "id": "Supervisor de Manutenção Industrial"},
	{"name": "Supervisor de Matéria-Prima", "id": "Supervisor de Matéria-Prima"},
	{"name": "Supervisor de Operações", "id": "Supervisor de Operações"},
	{"name": "Supervisor de Produção", "id": "Supervisor de Produção"},
	{"name": "Supervisor de Recursos Humanos", "id": "Supervisor de Recursos Humanos"},
	{"name": "Supervisor de Suprimentos", "id": "Supervisor de Suprimentos"},
	{"name": "Supervisor de Tesouraria", "id": "Supervisor de Tesouraria"},
	{"name": "Supervisor Financeiro", "id": "Supervisor Financeiro"},
	{"name": "Supervisor Fiscal", "id": "Supervisor Fiscal"},
	{"name": "Tabelião", "id": "Tabelião"},
	{"name": "Taxista", "id": "Taxista"},
	{"name": "Tecelão", "id": "Tecelão"},
	{"name": "Técnico em Kaizen", "id": "Técnico em Kaizen"},
	{"name": "Técnica Agropecuária", "id": "Técnica Agropecuária"},
	{"name": "Técnico  Administrativo ", "id": "Técnico  Administrativo "},
	{"name": "Técnico  em Recursos Humanos", "id": "Técnico  em Recursos Humanos"},
	{"name": "Técnico Agropecuário", "id": "Técnico Agropecuário"},
	{"name": "Técnico de Métodos Gráficos", "id": "Técnico de Métodos Gráficos"},
	{"name": "Técnico de Operação de Usina Hidrelétrica", "id": "Técnico de Operação de Usina Hidrelétrica"},
	{"name": "Técnico de Tinturaria", "id": "Técnico de Tinturaria"},
	{"name": "Técnico em Informática", "id": "Técnico em Informática"},
	{"name": "Técnico em Processamento", "id": "Técnico em Processamento"},
	{"name": "Técnico Agrícola", "id": "Técnico Agrícola"},
	{"name": "Técnico de Enfermagem", "id": "Técnico de Enfermagem"},
	{"name": "Técnico de Gesso", "id": "Técnico de Gesso"},
	{"name": "Técnico de Manutenção Elétrico", "id": "Técnico de Manutenção Elétrico"},
	{"name": "Técnico de Processos", "id": "Técnico de Processos"},
	{"name": "Técnico em Contabilidade", "id": "Técnico em Contabilidade"},
	{"name": "Técnico em Edificações", "id": "Técnico em Edificações"},
	{"name": "Técnico em Eletrônica", "id": "Técnico em Eletrônica"},
	{"name": "Técnico em Meio Ambiente", "id": "Técnico em Meio Ambiente"},
	{"name": "Técnico em Plástico", "id": "Técnico em Plástico"},
	{"name": "Técnico em Radiologia Médica", "id": "Técnico em Radiologia Médica"},
	{"name": "Técnico em Segurança do Trabalho", "id": "Técnico em Segurança do Trabalho"},
	{"name": "Técnico Mecânico", "id": "Técnico Mecânico"},
	{"name": "Técnico Químico Industrial", "id": "Técnico Químico Industrial"},
	{"name": "Tecnólogo do Produto Sênior", "id": "Tecnólogo do Produto Sênior"},
	{"name": "Tecnólogo em Gestão Financeira", "id": "Tecnólogo em Gestão Financeira"},
	{"name": "Tecnólogo em Telecomunicações", "id": "Tecnólogo em Telecomunicações"},
	{"name": "Tecnólogo", "id": "Tecnólogo"},
	{"name": "Tecnólogo de Processo de Produção", "id": "Tecnólogo de Processo de Produção"},
	{"name": "Tecnólogo em Processamento de Dados", "id": "Tecnólogo em Processamento de Dados"},
	{"name": "Tecnólogo Mecânico", "id": "Tecnólogo Mecânico"},
	{"name": "Telefonista", "id": "Telefonista"},
	{"name": "Tintureiro", "id": "Tintureiro"},
	{"name": "Torneiro Mecânico", "id": "Torneiro Mecânico"},
	{"name": "Tradutor", "id": "Tradutor"},
	{"name": "Vendedor", "id": "Vendedor"},
	{"name": "Vidreiro", "id": "Vidreiro"},
	{"name": "Vigilante", "id": "Vigilante"},
	{"name": "Web Designer", "id": "Web Designer"},
	{"name": "Zootécnico", "id": "Zootécnico"}
]
